import { create } from 'zustand';
import { Creator } from '~/clientApi/creator.model';

export type SelectCreatorStore = {
  isModalOpen: boolean;
  mode: 'all' | 'from-blocks';
  callback?: (creator: Creator) => void; // id is creator id
  setIsModalOpen: (
    isModalOpen: SelectCreatorStore['isModalOpen'],
    mode?: SelectCreatorStore['mode'],
    callback?: SelectCreatorStore['callback'],
  ) => void;
};
export const useSelectCreatorStore = create<SelectCreatorStore>((set) => ({
  isModalOpen: false,
  mode: 'all',
  callback: undefined,
  setIsModalOpen: (isModalOpen, mode = 'all', callback) =>
    set({ isModalOpen, mode, callback }),
}));
